module.exports = __webpack_public_path__ + "img/beroma.e1127a03.webp";